import HttpClient from '../../services/http-client';
import { ICountryResponse, IStateResponse, ICityResponse, IZipCodeResponse } from '../../../model/base/location-response';

const listCountries = async (name?: string): Promise<ICountryResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: '/Base/Country',
        params: name ? { Name: name } : undefined
    }).then((response) => response.data);
};

const listStates = async (countryId: number): Promise<IStateResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: '/Base/State',
        params: { CountryId: countryId }
    }).then((response) => response.data);
};

const listCities = async (stateId: number): Promise<ICityResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: '/Base/City',
        params: { StateId: stateId }
    }).then((response) => response.data);
};

const lookupZipCode = async (zipCode: string): Promise<IZipCodeResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/Base/ZipCode/${zipCode}`
    }).then((response) => response.data);
};

const LocationAppService = { listCountries, listStates, listCities, lookupZipCode };
export default LocationAppService;
